import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ title, children }) => (
  <div className="card">
    <h6>{title}</h6>
    <div className="card-content">
      {children}
    </div>
  </div>
);

Card.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Card;
